// extracted by mini-css-extract-plugin
export var container = "_du-0";
export var icon = "_du-1";
export var text = "_du-2";